module.exports = __webpack_public_path__ + "50728bc496f4c883b22f5457d81429c5.svg";